export class Ferramenta {
  constructor({
    uuid,
    codigo,
    descricao,
    grupo,
    subgrupo,
    url,
    tempoPermanencia,
    atributos,
    checkLists,
    depositoLocalUuid,
    unidadeMedida,
    acessorios,
  }) {
    this.uuid = uuid;
    this.codigo = codigo;
    this.descricao = descricao;
    this.grupo = grupo;
    this.subgrupo = subgrupo;
    this.url = url;
    this.tempoPermanencia = tempoPermanencia;
    this.atributos = atributos;
    this.checkLists = checkLists;
    this.unidadeMedida = unidadeMedida;
    this.acessorios = acessorios;
    this.depositoLocalUuid = depositoLocalUuid;
  }
}
